import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {attr as svgAttr} from 'tiny-svg';
import Selection from "diagram-js/lib/features/selection/Selection";

export class ElementVisibilityHandler implements CommandHandler {

  constructor(private graphicsFactory, private elementRegistry, private overlays, private pathwaysViewerCommands, private selection: Selection) {
  }

  postExecute(context): any {
    const element = context.element;
    const hidden = context.hidden;
    this.setElementHidden(element, hidden);
  }

  private setElementHidden(element, hidden: boolean) {
    element.hidden = hidden;
    const gfx = this.elementRegistry.getGraphics(element);
    if (gfx) {
      if (element.hidden) {
        svgAttr(gfx, 'display', 'none');

      } else {
        svgAttr(gfx, 'display', 'block');
      }

      let overlays = this.overlays.get({element: element});

      overlays = overlays.concat(this.getOverlayForSelectedItem(element,hidden));

      if (overlays && overlays.length > 0) {
        overlays.forEach((overlay) => {
          const htmlContainer = overlay.htmlContainer;
          this.setVisible(htmlContainer,!overlay.element.hidden);
        });
      }
    } else {
      // this will render the floating nodes when navigate to neighborhood
      if(!hidden && element.businessObject.markedToBeRendered === false){
        this.pathwaysViewerCommands.renderElement(element);
      }
    }
  }

  private setVisible(el, visible) {
    el.style.display = visible === false ? 'none' : '';
    el.hidden = visible === false ? true : false;
    el.style.hidden =  visible === false ? true : false;
  }

  private getOverlayForSelectedItem(element,hidden) {
    let selectedElementOverlay = [];
    let isSelected = this.selection.isSelected(element);
    if(isSelected) {
      selectedElementOverlay = this.overlays.get({element: element.parent.id});
      selectedElementOverlay.forEach(overlay => {
        overlay.element.hidden = hidden;
      });
    }
    return selectedElementOverlay;
  }
}
